import fetch from 'isomorphic-unfetch';

// Copied this from the RegistrationModel api and simplified it since we only
// have a single GET request in this api.
const request = async path => {
  const init = {
    method: 'get',
  };

  init.headers = {
    'Content-Type': 'application/json',
  };

  const response = await fetch(path, init);

  if (response.status >= 400) {
    const e = new Error('Request failed');
    e.response = await response.json();
    e.code = response.status;
    throw e;
  }

  return await response.json();
};

// Call the api and allow the user to opt in to using cookies.
export async function gdprOptIn() {
  return request('/api/member/gdpr-opt-in-cookies/');
}
